import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const BoxShopEmptyIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="200" height="186" viewBox="0 0 200 186" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="64.7276" height="64.7276" transform="matrix(0.866025 -0.5 2.20305e-08 1 32.3633 65)" fill="#3B3184" />
    <mask
      id="mask0_38303_85503"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="88"
      y="32"
      width="57"
      height="98"
    >
      <rect
        width="64.7276"
        height="64.7276"
        transform="matrix(0.866025 0.5 -2.20305e-08 1 88.4336 32.6367)"
        fill="#6450F7"
      />
    </mask>
    <g mask="url(#mask0_38303_85503)">
      <rect
        width="64.7276"
        height="64.7276"
        transform="matrix(0.866025 0.5 -2.20305e-08 1 88.4336 32.6367)"
        fill="#3B3184"
      />
      <ellipse cx="107.658" cy="51.1261" rx="36.8407" ry="62.4154" fill="#4B3DB2" />
    </g>
    <mask
      id="mask1_38303_85503"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="77"
      y="40"
      width="57"
      height="90"
    >
      <rect
        width="63.4286"
        height="59.3613"
        transform="matrix(0.883761 0.467938 -2.40221e-08 1 77.7188 40.4316)"
        fill="#6450F7"
      />
    </mask>
    <g mask="url(#mask1_38303_85503)">
      <rect
        width="63.4286"
        height="59.3613"
        transform="matrix(0.883761 0.467938 -2.40221e-08 1 77.7188 40.4316)"
        fill="#F2F2F2"
      />
      <ellipse cx="87.0595" cy="41.4847" rx="36.8407" ry="57.2407" fill="white" />
    </g>
    <mask
      id="mask2_38303_85503"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="66"
      y="48"
      width="57"
      height="90"
    >
      <rect
        width="63.4286"
        height="59.3613"
        transform="matrix(0.883761 0.467938 -2.40221e-08 1 66.5469 48.8711)"
        fill="#6450F7"
      />
    </mask>
    <g mask="url(#mask2_38303_85503)">
      <rect
        width="63.4286"
        height="59.3613"
        transform="matrix(0.883761 0.467938 -2.40221e-08 1 66.5469 48.8711)"
        fill="#F2F2F2"
      />
      <ellipse cx="69.2052" cy="48.8715" rx="36.8407" ry="57.2407" fill="white" />
    </g>
    <mask
      id="mask3_38303_85503"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="55"
      y="54"
      width="57"
      height="90"
    >
      <rect
        width="63.4286"
        height="59.3613"
        transform="matrix(0.883761 0.467938 -2.40221e-08 1 55.8906 54.207)"
        fill="#6450F7"
      />
    </mask>
    <g mask="url(#mask3_38303_85503)">
      <rect
        width="63.4286"
        height="59.3613"
        transform="matrix(0.883761 0.467938 -2.40221e-08 1 55.8906 54.207)"
        fill="#F2F2F2"
      />
      <ellipse cx="52.1374" cy="61.4929" rx="36.8407" ry="57.2407" fill="white" />
    </g>
    <mask
      id="mask4_38303_85503"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="32"
      y="65"
      width="57"
      height="98"
    >
      <rect
        width="64.7276"
        height="64.7276"
        transform="matrix(0.866025 0.5 -2.20305e-08 1 32.3633 65.0098)"
        fill="#6450F7"
      />
    </mask>
    <g mask="url(#mask4_38303_85503)">
      <rect
        width="64.7276"
        height="64.7276"
        transform="matrix(0.866025 0.5 -2.20305e-08 1 32.3633 65.0098)"
        fill="#4B3DB2"
      />
      <ellipse cx="52.528" cy="72.4666" rx="36.8407" ry="62.4154" fill="#6450F7" />
    </g>
    <rect
      width="64.7276"
      height="64.7276"
      transform="matrix(0.866025 -0.5 2.20305e-08 1 88.4336 97.375)"
      fill="#3B3184"
    />
    <path d="M88.3594 97.3398L144.425 64.9701L179.164 69.956L123.098 102.326L88.3594 97.3398Z" fill="#6450F7" />
    <path d="M32.3619 65.0044L88.4279 32.6346L79.4188 0.264879L23.3527 32.6346L32.3619 65.0044Z" fill="#4B3DB2" />
    <path d="M144.466 65.0059L88.4267 32.6361L107.347 4.24848L163.386 36.6182L144.466 65.0059Z" fill="#D9D9D9" />
    <path d="M144.466 65.0059L88.4267 32.6361L107.347 4.24848L163.386 36.6182L144.466 65.0059Z" fill="#6450F7" />
    <path d="M88.4183 97.4194L32.3795 65.0496L15.8409 40.4324L71.8797 72.8021L88.4183 97.4194Z" fill="#4B3DB2" />
  </svg>
)
